var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarLineChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17400",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(344 235)",
    fill: "#185edf",
    stroke: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-344 -235)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17399",
    fill: "none",
    d: "M344 235h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21628",
    d: "M346.5 261.564c0-.517.56-.936 1.25-.936h22.5c.69 0 1.25.419 1.25.936 0 .517-.56.936-1.25.936h-22.5c-.69 0-1.25-.419-1.25-.936Zm6.25-10.292c0-.517-.56-.936-1.25-.936s-1.25.419-1.25.936v7.485h2.5Zm15-6.55c0-.517-.56-.936-1.25-.936s-1.25.419-1.25.936v14.035h2.5Zm-10 3.743c0-.517-.56-.936-1.25-.936s-1.25.419-1.25.936v10.292h2.5Zm5 4.21c0-.517-.56-.936-1.25-.936s-1.25.419-1.25.936v6.082h2.5Z",
    fill: "#185edf"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21629",
    d: "m350.013 247.164 5.6-4.732 5.106 1.121 5.106-4.733",
    fill: "none",
    stroke: "#185edf",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLineChartBlue);
export default __webpack_public_path__ + "static/media/bar-line-chart-blue.d697eddc6c454243ca9f179dadfc13c1.svg";
export { ForwardRef as ReactComponent };